export const IconDocument = () => (
	<svg
		width="30"
		height="30"
		viewBox="0 0 30 30"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M24.3 3.2H5.7v24h18.6v-24Zm-1.6 1.6v20.8H7.3V4.8h15.4Z"
			fillRule="nonzero"
		/>
		<path d="M10 10h10v1.4H10zm0 4h10v1.4H10zm0 4h10v1.4H10z" />
	</svg>
);

export const IconInvalid = () => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0Zm0 1.6C6.256 1.6 1.6 6.256 1.6 12c0 5.744 4.656 10.4 10.4 10.4 5.744 0 10.4-4.656 10.4-10.4 0-5.744-4.656-10.4-10.4-10.4Z" />
		<path d="M13.2 16.007V18.7h-2.4v-2.693h2.4ZM10.954 5.3h2.078v2.876l-.304 5.732h-1.47l-.304-5.743V5.3Z" />
	</svg>
);

export const IconDelete = () => (
	<svg
		width="13"
		height="13"
		viewBox="0 0 13 13"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path d="m11.434.434 1.132 1.132L7.63 6.5l4.935 4.934-1.132 1.132L6.5 7.63l-4.934 4.935-1.132-1.132L5.37 6.5.434 1.566 1.566.434 6.5 5.37 11.434.434Z" />
	</svg>
);
